var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":"true"}},[_c('WorkflowDetails',{attrs:{"Flag":_vm.flag},on:{"backpage":_vm.Backpage,"CreateNotifiy":_vm.CreateData,"UpdateNotifiy":_vm.UpdateNotifiy}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }